import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Source, Layer, Marker } from "react-map-gl/mapbox";
import { bezierSpline } from "@turf/bezier-spline";
import { useMapContext } from "../../../contexts/MapContext";
import { CustomMarker } from "@/domains/map/components/SourcesAndLayers/PinMarker/CustomMarker";
export const TravelTimeLineSourceAndLayer = () => {
    var _a, _b;
    const { destination, viewport, travelTimes, style } = useMapContext();
    const lineColor = "#477BFF";
    const startLat = viewport.center[1];
    const startLng = viewport.center[0];
    const endLat = (_a = destination === null || destination === void 0 ? void 0 : destination.coordinates.lat) !== null && _a !== void 0 ? _a : null;
    const endLng = (_b = destination === null || destination === void 0 ? void 0 : destination.coordinates.lng) !== null && _b !== void 0 ? _b : null;
    const midLng = endLng !== null ? (startLng + endLng) / 2 : startLng;
    const midLat = endLat !== null ? (startLat + endLat) / 2 : startLat;
    const distLng = endLng !== null ? Math.abs(startLng - endLng) : 0;
    const distLat = endLat !== null ? Math.abs(startLat - endLat) : 0;
    const curveLat = endLat !== null && distLat < distLng ? endLat : midLat;
    const curveLng = endLng !== null && distLng < distLat ? endLng : midLng;
    const curved = useMemo(() => {
        if (!destination || endLat === null || endLng === null)
            return null;
        // Lower resolution to reduce CPU cost during renders.
        return bezierSpline({
            type: "Feature",
            properties: {},
            geometry: {
                type: "LineString",
                coordinates: [
                    [startLng, startLat],
                    [curveLng, curveLat],
                    [endLng, endLat],
                ],
            },
        }, { resolution: 500 });
    }, [destination, startLng, startLat, curveLng, curveLat, endLng, endLat]);
    const markerColor = style === "standard" ? "#000" : "#FFF";
    if (!destination || !curved || travelTimes.length === 0)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Source, { type: "geojson", id: "travel-time-line-source", data: curved, children: _jsx(Layer, { type: "line", id: "travel-time-line-layer", paint: {
                        "line-color": lineColor,
                        "line-width": 5,
                        "line-dasharray": [2, 2],
                    } }) }), _jsx(Marker, { longitude: destination.coordinates.lng, latitude: destination.coordinates.lat, anchor: "bottom", children: _jsx(CustomMarker, { color: markerColor }) })] }));
};
